var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyXcu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136714)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1516_136714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 28H0V0H28V28Z",
    fill: "#C26A44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5005 19.5C21.5005 19.6326 21.4478 19.7598 21.3541 19.8536C21.2603 19.9473 21.1331 20 21.0005 20H16.0005C15.8679 20 15.7407 19.9473 15.6469 19.8536C15.5532 19.7598 15.5005 19.6326 15.5005 19.5V15C15.5005 14.8674 15.5532 14.7402 15.6469 14.6464C15.7407 14.5527 15.8679 14.5 16.0005 14.5H21.0005C21.1331 14.5 21.2603 14.5527 21.3541 14.6464C21.4478 14.7402 21.5005 14.8674 21.5005 15V19.5ZM12.4995 19.5C12.4995 19.6326 12.4468 19.7598 12.3531 19.8536C12.2593 19.9473 12.1321 20 11.9995 20H7C6.86739 20 6.74021 19.9473 6.64645 19.8536C6.55268 19.7598 6.5 19.6326 6.5 19.5V15C6.5 14.8674 6.55268 14.7402 6.64645 14.6464C6.74021 14.5527 6.86739 14.5 7 14.5H11.9995C12.1321 14.5 12.2593 14.5527 12.3531 14.6464C12.4468 14.7402 12.4995 14.8674 12.4995 15V19.5ZM16.9995 11.5C16.9995 11.6326 16.9468 11.7598 16.8531 11.8536C16.7593 11.9473 16.6321 12 16.4995 12H11.5C11.3674 12 11.2402 11.9473 11.1464 11.8536C11.0527 11.7598 11 11.6326 11 11.5V7C11 6.86739 11.0527 6.74021 11.1464 6.64645C11.2402 6.55268 11.3674 6.5 11.5 6.5H16.4995C16.6321 6.5 16.7593 6.55268 16.8531 6.64645C16.9468 6.74021 16.9995 6.86739 16.9995 7V11.5Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7H16.5L11.5 11.5V7ZM7 15H12L7 19.5V15ZM16 15H21L16 19.5V15Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1516_136714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyXcu);
export default __webpack_public_path__ + "static/media/Currency=XCU.ebe517ca4bdd76bfd1f2027a8b2fbd0b.svg";
export { ForwardRef as ReactComponent };